import React from 'react'
import { RefreshEnvOnPipe } from '@morningtrain/react-resources'
import { CallbackOnPipe } from '@morningtrain/react-helpers'
import { Env } from '@morningtrain/helpers'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'

export default function RefreshEnvPipes () {
  const hasFirm = Env.get('globals.has_firm');
  return (
    <>
      {hasFirm ? <RefreshEnvOnPipe path='globals.firms' namespace='api' resourceName='env.firms' operationName='firms' /> : false }
      <RefreshEnvOnPipe path='globals.departments' namespace='api' resourceName='env.departments' operationName='departments' />
      <WhenDeviceNotAuthorized>
        <CallbackOnPipe callback={() => {
          if (Env.get('globals.firms', []).length > 1) {
            Env.set('globals.firm', null)
          }
          if (Env.get('globals.departments', []).length > 1) {
            Env.set('globals.department', null)
          }
        }}
        />
      </WhenDeviceNotAuthorized>
    </>
  )
}
